import React from 'react';
import { graphql } from 'gatsby';

import SocialShare from '../components/SocialShare';
import Layout from '../components/Layout';
import PostTitle from '../components/Title/PostTitle';
import { SectionLayout } from '../components/Layouts';
import * as T from '../components/Typography';
import { Row, Col } from '../components/Grid';
import Image from '../components/PreviewCompatibleImage';
import composeStyle from '../utils/composeStyle';

import * as S from './style';
import Button from '../components/Button';

const Subtitle = composeStyle(T.H4SemiBold, 'H4SemiBold', 'P16Bold');

export const JobTemplate = ({
  title = 'title...',
  subtitle = 'subtitle...',
  category,
  imageInfo,
  content = 'content...',
  candidateFile,
  applicationFile,
  privacyFile,
}) => {
  return (
    <>
      <SectionLayout>
        <Row>
          <Col mb="1.5rem" w={[4, 6, 8]}>
            <PostTitle category={category}>{title}</PostTitle>
          </Col>
        </Row>

        <S.PostDesktopWrapper>
          <Row jc="space-between">
            <Col w={[4, 6, 7]}>
              <S.Content>
                <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                  {subtitle}
                </Subtitle>
                <S.PostsContentContainer>
                  {content && (
                    <S.PostsContentContainer
                      dangerouslySetInnerHTML={{
                        __html: content,
                      }}
                    />
                  )}
                </S.PostsContentContainer>
              </S.Content>
            </Col>
            <Col w={[4, 6, 4]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} style={{ maxHeight: '250px' }} />
              </S.ImgContainer>
              <Button
                color="blue"
                external
                to={candidateFile.publicURL}
                style={{ marginTop: '3rem' }}
              >
                <T.Button16 color="white">Candidate Pack</T.Button16>
              </Button>
              <Button color="blue" external to={applicationFile.publicURL} style={{ marginTop: 9 }}>
                <T.Button16 color="white">Application Form</T.Button16>
              </Button>
              <Button color="blue" external to={privacyFile.publicURL} style={{ marginTop: 9 }}>
                <T.Button16 color="white">Privacy policy</T.Button16>
              </Button>
            </Col>
          </Row>
        </S.PostDesktopWrapper>

        <S.PostTabletAndMobileWrapper>
          <Row>
            <Col w={[4, 3, 8]}>
              <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                {subtitle}
              </Subtitle>
            </Col>
            <Col w={[4, 3, 8]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} />
              </S.ImgContainer>
            </Col>

            <Col w={[4, 6, 8]}>
              {content && (
                <S.JobContent>
                  <S.PostsContentContainer
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </S.JobContent>
              )}
            </Col>
            <Col w={[4, 3, 8]}>
              <Button
                color="blue"
                external
                caps={false}
                to={candidateFile.publicURL}
                style={{ marginTop: '2rem' }}
              >
                <T.Button16 color="white">Candidate pack</T.Button16>
              </Button>
              <Button
                color="blue"
                external
                caps={false}
                to={applicationFile.publicURL}
                style={{ marginTop: 9 }}
              >
                <T.Button16 color="white">Application form</T.Button16>
              </Button>
              <Button
                color="blue"
                external
                caps={false}
                to={privacyFile.publicURL}
                style={{ marginTop: 9 }}
              >
                <T.Button16 color="white">Privacy policy</T.Button16>
              </Button>
            </Col>
          </Row>
        </S.PostTabletAndMobileWrapper>

        {/* social share */}
        <Row>
          <Col mt={5} w={[4, 2, 3]}>
            <SocialShare jc="flex-start" jcT="flex-start" jcM="center" />
          </Col>
        </Row>
      </SectionLayout>
    </>
  );
};

const JobPage = ({ data }) => {
  const {
    markdownRemark: {
      html: content,
      frontmatter: {
        title,
        subtitle,
        category,
        postImage,
        candidateFile,
        applicationFile,
        privacyFile,
      } = {},
    } = {},
  } = data;
  return (
    <Layout isPost>
      <JobTemplate
        content={content}
        title={title}
        subtitle={subtitle}
        category={category}
        imageInfo={postImage}
        candidateFile={candidateFile}
        applicationFile={applicationFile}
        privacyFile={privacyFile}
      />
    </Layout>
  );
};

export const JobPost = graphql`
  query jobPostQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        subtitle
        category
        postImage {
          childImageSharp {
            fluid(quality: 100, maxWidth: 360) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        candidateFile {
          publicURL
        }
        applicationFile {
          publicURL
        }
        privacyFile {
          publicURL
        }
      }
    }
  }
`;

export default JobPage;
